// extracted by mini-css-extract-plugin
export default {"Toggle":"RolesTable_Toggle__1pPdr","Chevron":"RolesTable_Chevron__GR4vK"};